const AUTH_ROUTE = '/';
const HOME_ROUTE = '/home';
const CREATE_ROUTE = '/create';
const PREVIEW_ROUTE = '/preview';
const STATIC_ROUTE = '/terms-of-service';

export { AUTH_ROUTE, HOME_ROUTE, CREATE_ROUTE, PREVIEW_ROUTE, STATIC_ROUTE };
